var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytic5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16406 0.5C1.33564 0.5 0.664062 1.17157 0.664062 2V24C0.664062 24.8284 1.33563 25.5 2.16406 25.5H12.1641C12.9925 25.5 13.6641 24.8284 13.6641 24V21V17V13V9V5V2C13.6641 1.17157 12.9925 0.5 12.1641 0.5H2.16406ZM12.6641 4.5L8.16406 4.5C7.88792 4.5 7.66406 4.72386 7.66406 5C7.66406 5.27614 7.88792 5.5 8.16406 5.5L12.6641 5.5V8.5H10.1641C9.88792 8.5 9.66406 8.72386 9.66406 9C9.66406 9.27614 9.88792 9.5 10.1641 9.5H12.6641V12.5H8.16406C7.88792 12.5 7.66406 12.7239 7.66406 13C7.66406 13.2761 7.88792 13.5 8.16406 13.5H12.6641V16.5H10.1641C9.88792 16.5 9.66406 16.7239 9.66406 17C9.66406 17.2761 9.88792 17.5 10.1641 17.5H12.6641V20.5H8.16406C7.88792 20.5 7.66406 20.7239 7.66406 21C7.66406 21.2761 7.88792 21.5 8.16406 21.5H12.6641V24C12.6641 24.2761 12.4402 24.5 12.1641 24.5H2.16406C1.88792 24.5 1.66406 24.2761 1.66406 24V2C1.66406 1.72386 1.88792 1.5 2.16406 1.5H12.1641C12.4402 1.5 12.6641 1.72386 12.6641 2V4.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytic5);
export default __webpack_public_path__ + "static/media/analytic5.12e7d8d16facaaa067c4698621a9a3d5.svg";
export { ForwardRef as ReactComponent };